import { render } from "./CookieBar.vue?vue&type=template&id=1b60d2d8&ts=true"
import script from "./CookieBar.vue?vue&type=script&lang=ts"
export * from "./CookieBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__